import { environment } from "src/environments/environment";
import { DirectoryDomain } from "../directory/enums/DirectoryDomain.enum";

export class GraphConstants {
    public static readonly PermissionsApp: string = 'microsoft.graph.appRole';
    public static readonly PermissionsScope: string = 'microsoft.graph.permissionScope';

    public static readonly DefaultGraphDomainString: string = `${environment.idampUserDefaultDomain}`;
    public static readonly DefaultGraphDomain: DirectoryDomain = this.getDirectoryDomain(environment.idampUserDefaultDomain) ?? DirectoryDomain.Chevron;

    public static readonly AppPermissionsDisplayValues:Map<string,string> = new Map([
        [this.PermissionsApp, 'application'],
        [this.PermissionsScope, 'delegated']
    ]);

    public static getDirectoryDomain(domainString: string): DirectoryDomain | undefined {
        return Object.values(DirectoryDomain).find(domain => domain === domainString);
    }
}